module.exports = __webpack_public_path__ + "static/bannerMetal-f27eb7f8ed07d2a11bcdae5ed7434c0d.png";